module.exports = __webpack_public_path__ + "static/img/product-16.688fb30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-16.png
// module id = 9SQp
// module chunks = 0